import { Fragment } from "react";

const addPromoTile = ({ promoTile, items }) => {
  if (!promoTile) {
    return items;
  }

  const { component, position } = promoTile;

  return [
    ...items.slice(0, position),
    <Fragment key="promoTile">{component}</Fragment>,
    ...items.slice(position)
  ];
};

export default addPromoTile;
